export const COLUMN_TYPE = 'COLUMN';
export const COLUMN_DISPLAY_NAME = 'Column';
export const COLUMN_DEFAULT_TITLE = 'New Column';
export const COLUMN_DEFAULT_HEIGHT_IN_GRID_UNIT = 15;

export const IN_LIST_MODE = {
    IN_LIST: 'in-list',
    IN_LIST_INBOX: 'in-list-inbox',
    IN_LIST_DOCUMENT_MODE: 'in-list-document-mode',
};
